import api from './api';

const productsService = {
  // Récupérer tous les produits actifs
  getActiveProducts: async () => {
    const response = await api.get('/public/products/active');
    return response.data;
  },

  // Récupérer les produits par profil et âge
  getProductsByProfilAndAge: async (profilTypeId, agesSectionId) => {
    const response = await api.get(`/public/products/profil/${profilTypeId}/age/${agesSectionId}`);
    return response.data;
  },

  // Récupérer les produits par type (physical/virtual)
  getProductsByType: async (productType) => {
    const response = await api.get(`/public/products/type/${productType}`);
    return response.data;
  },

  // Récupérer un produit par ID
  getProductById: async (id) => {
    const response = await api.get(`/public/products/${id}`);
    return response.data;
  },

  // Récupérer les produits gratuits ou payants
  async getFreeOrPaidProducts(isFree) {
    const response = await api.get(`/public/products/free/${isFree}`);
    return response.data;
  },

  // Vérifier l'accès à un contenu virtuel
  async checkVirtualContentAccess(productId, token) {
    const response = await api.get(`/public/products/${productId}/check-access`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Récupérer les produits gratuits
  getFreeProducts: async () => {
    const products = await productsService.getActiveProducts();
    return products.filter(p => p.is_free);
  },

  // Récupérer les produits payants
  getPaidProducts: async () => {
    const products = await productsService.getActiveProducts();
    return products.filter(p => !p.is_free);
  }
};

export default productsService;
